module.exports = __webpack_public_path__ + "static/img/卓阳集团应邀参加西藏.17fac8eb.jpg";